export interface RoleDto {
  name: string;
  description: string;
}

export class RolesLookup {
  public static readonly roles: RoleDto[] = [
    {
      name: 'mhs.scm.user',
      description: 'RIS',
    },
    {
      name: 'mhs.scmmanager.user',
      description: 'RIS Manager',
    },
  ];
}
